import { lazy } from 'react'

import {isProduction} from '@utils'

export const AnalyticsRoutes = [
    {
        path: '/analytics/overview',
        component: lazy(() => import('../views/overview')),
        appLayout: true,
        className: 'chat-application custom-application',
        meta: {
            action: 'call',
            resource: "ANA_OVERVIEW_STATISTICS"
        }
    },
    {
        path: '/analytics/issues',
        component: lazy(() => import('../views/issues')),
        appLayout: true,
        className: 'chat-application custom-application',
        meta: {
            action: 'call',
            resource: "ANA_ISSUES_STATISTICS"
        }
    },
    {
        path: '/analytics/responses',
        component: lazy(() => import('../views/responses')),
        appLayout: true,
        className: 'chat-application custom-application',
        meta: {
            action: 'call',
            resource: "ANA_RESPONSES_STATISTICS"
        }
    },
    {
        path: '/analytics/reports',
        component: lazy(() => import('../views/inspections')),
        appLayout: true,
        className: 'chat-application custom-application',
        meta: {
            action: 'call',
            resource: "ANA_REPORTS_STATISTICS"
        }
    }
]

